// extracted by mini-css-extract-plugin
export default {"container":"PihA","header":"xMdP","content":"hTXo","actions":"hgOP","btn":"L5hU","red":"GpEb","blue":"pnrc"};